export default __webpack_public_path__ + "static/media/PhotoMyrtleBeach.com-53.14643f8f.jpg";